export const stringNumeros = (value: string) => {
    const numberPattern = /\d+/g;
    const ret = (value || '').match(numberPattern);
    if (!ret) return '';
    return ret.join('');
}